// Datas da agenda no fuso do navegador. "Dia" é sempre uma string AAAA-MM-DD local.

const dois = (n: number) => String(n).padStart(2, "0");

export function diaDe(d: Date): string {
  return `${d.getFullYear()}-${dois(d.getMonth() + 1)}-${dois(d.getDate())}`;
}

export function hoje(): string {
  return diaDe(new Date());
}

/** Meia-noite local do dia. */
export function meiaNoite(dia: string): Date {
  const [a, m, d] = dia.split("-").map(Number) as [number, number, number];
  return new Date(a, m - 1, d);
}

export function somarDias(dia: string, n: number): string {
  const d = meiaNoite(dia);
  d.setDate(d.getDate() + n);
  return diaDe(d);
}

/** Segunda-feira da semana do dia. */
export function inicioDaSemana(dia: string): string {
  const semana = meiaNoite(dia).getDay(); // 0 = domingo
  return somarDias(dia, semana === 0 ? -6 : 1 - semana);
}

/** Converte o timestamptz do Postgres ("2026-10-20 23:49:09+00") ou ISO em Date. */
export function instante(valor: string): Date {
  return new Date(valor.replace(" ", "T").replace(/([+-]\d{2})$/, "$1:00"));
}

export function minutosDoDia(valor: string | Date): number {
  const d = typeof valor === "string" ? instante(valor) : valor;
  return d.getHours() * 60 + d.getMinutes();
}

/** Instante ISO (UTC) do dia + minutos locais. */
export function instanteEm(dia: string, minutos: number): string {
  const d = meiaNoite(dia);
  d.setMinutes(minutos);
  return d.toISOString();
}

export function formatarHora(valor: string | Date): string {
  const d = typeof valor === "string" ? instante(valor) : valor;
  return `${dois(d.getHours())}:${dois(d.getMinutes())}`;
}

export function horaParaMinutos(hora: string): number {
  const [h, m] = hora.split(":").map(Number) as [number, number];
  return h * 60 + m;
}

export function minutosParaHora(min: number): string {
  return `${dois(Math.floor(min / 60))}:${dois(min % 60)}`;
}

const fmtDiaCurto = new Intl.DateTimeFormat("pt-BR", { weekday: "short", day: "numeric" });
const fmtDiaLongo = new Intl.DateTimeFormat("pt-BR", { weekday: "long", day: "numeric", month: "long" });
const fmtMes = new Intl.DateTimeFormat("pt-BR", { month: "long", year: "numeric" });

export const rotuloDiaCurto = (dia: string) => fmtDiaCurto.format(meiaNoite(dia)).replace(".", "");
export const rotuloDiaLongo = (dia: string) => {
  const t = fmtDiaLongo.format(meiaNoite(dia));
  return t.charAt(0).toUpperCase() + t.slice(1);
};
export const rotuloMes = (dia: string) => {
  const t = fmtMes.format(meiaNoite(dia));
  return t.charAt(0).toUpperCase() + t.slice(1);
};
